module.exports = __webpack_public_path__ + "img/right.533c9b5d.svg";